import * as tslib_1 from "tslib";
import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { TextboxField } from '../';
import { formatNumber, parseNumber } from '../../../utilities';
export const getCurrencyType = (locale) => {
    // for now only supporting USD
    switch (locale) {
        default:
            return 'USD';
    }
};
export const CurrencyField = (_a) => {
    var { type, step, value, locale } = _a, props = tslib_1.__rest(_a, ["type", "step", "value", "locale"]);
    const { id, form } = props;
    const { values, handleBlur, setValues } = form;
    const [hasFocus, setHasFocus] = useState(false);
    const currency = useMemo(() => getCurrencyType(locale), [locale]);
    const formattedValue = useMemo(() => {
        const currencyValue = value || _.get(values, id);
        // format value as currency
        return _.isNumber(currencyValue) || currencyValue
            ? formatNumber(currencyValue, { locale, currency })
            : formatNumber(0, { locale, currency });
    }, [id, value, values, locale, currency]);
    const overrideProps = useMemo(() => {
        // use inputMode="decimal" instead of type="number" (so user can still enter delimiters like comma)
        if (hasFocus) {
            return {
                inputMode: 'decimal',
            };
        }
        return {
            value: formattedValue,
        };
    }, [hasFocus, formattedValue]);
    const onFocus = () => {
        // when focusing, set form value to formatted currency value
        setValues(_.set(Object.assign({}, values), id, formattedValue));
        setHasFocus(true);
    };
    const onBlur = (e) => {
        // when blurring, set form value to number parsed from input value
        setValues(_.set(Object.assign({}, values), id, e.target.value && parseNumber(e.target.value, locale)));
        setHasFocus(false);
        handleBlur(e);
    };
    return React.createElement(TextboxField, Object.assign({}, props, overrideProps, { onfocus: onFocus, onblur: onBlur }));
};
//# sourceMappingURL=Currency.js.map